import { c } from 'react-compiler-runtime';
import React from 'react';
import styles from './UnstyledTextInput.module.css.js';
import { clsx } from 'clsx';
import { BoxWithFallback } from './BoxWithFallback.js';
import { jsx } from 'react/jsx-runtime';

const UnstyledTextInput = /*#__PURE__*/React.forwardRef(function UnstyledTextInput(t0, forwardRef) {
  const $ = c(9);
  let className;
  let rest;
  if ($[0] !== t0) {
    ({
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = clsx(className, styles.Input);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== forwardRef || $[6] !== rest || $[7] !== t1) {
    t2 = /*#__PURE__*/jsx(BoxWithFallback, {
      as: "input",
      ref: forwardRef,
      ...rest,
      className: t1
    });
    $[5] = forwardRef;
    $[6] = rest;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
});
UnstyledTextInput.displayName = 'UnstyledTextInput';

export { UnstyledTextInput as default };
